import React from 'react';
import PropTypes from 'prop-types';
import t from '../../lib/I18n';

export default function RegistrationBenefits({benefits}) {
    return (
        <div className="content-wrapper__usps__benefits">
            {benefits.map(benefit => (
                <div key={benefit}>
                    <i className="otrl otrl-tick" />
                    <span>{t(benefit)}</span>
                </div>
            ))}
        </div>
    );
}

RegistrationBenefits.propTypes = {
    benefits: PropTypes.arrayOf(PropTypes.string),
};



// WEBPACK FOOTER //
// ./src/components/login/RegistrationBenefits.js